import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const [availableLanguages, setAvailableLanguages] = useState([
    { language_code: 'no', language_name: 'Norsk' },
    { language_code: 'en', language_name: 'English' }
  ]);

  useEffect(() => {
    fetchAvailableLanguages();
  }, []);

  const fetchAvailableLanguages = async () => {
    try {
      const response = await axios.get(`${API}/languages`);
      setAvailableLanguages(response.data);
    } catch (error) {
      console.error('Failed to fetch languages:', error);
      // Keep default languages if fetch fails
    }
  };

  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    // Mark that user has manually set language (prevents auto-override from organization settings)
    sessionStorage.setItem('userLanguageSet', 'true');
    i18n.changeLanguage(newLang);
    console.log(`User manually changed language to: ${newLang}`);
  };

  const currentLanguage = availableLanguages.find(lang => lang.language_code === i18n.language);

  return (
    <div
      className="language-switcher"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '0.5rem 1rem',
        background: 'rgba(80, 227, 194, 0.1)',
        border: '1px solid rgba(80, 227, 194, 0.3)',
        borderRadius: '8px',
        color: '#50E3C2'
      }}
    >
      <Globe size={18} />
      <select
        value={i18n.language}
        onChange={handleLanguageChange}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#50E3C2',
          cursor: 'pointer',
          fontSize: '0.9rem',
          fontWeight: '500',
          outline: 'none'
        }}
      >
        {availableLanguages.map(lang => (
          <option key={lang.language_code} value={lang.language_code} style={{ background: '#1a1a1a', color: 'white' }}>
            {lang.language_name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
